import { Config } from '../config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationNotificationBadgeData } from '../model/user';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  /**
   * Creates a new instance of AlertsService
   *
   * @param http
   */
  public constructor(private http: HttpClient) {}

  /**
   * Loads the notifications from the endpoint
   */
  public loadNotifications(): Observable<any> {
    return this.http.post(`${Config.apiRoot.uri}reports/alerts`, null);
  }

  /**
   * Returns the total amount of unresolved alerts.
   */
  public getNotificationCount(): Observable<NavigationNotificationBadgeData> {
    return this.loadNotifications().pipe(
      map((response) => {
        return {
          total: response.data.filter((row) => {
            return row.alertResolvedStatus === 'Unresolved' && row.vrmStatus === 'Active';
          }).length,
        };
      })
    );
  }
}
